export default __webpack_public_path__ + "557bbecbd4fb377f4ccaea4d48611f67.svg";